import { useEffect, useState } from 'react';
import Link from 'next/link';

import { IMenuItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';

import { NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { AdvertisingLabelWithTooltip } from '@r1-frontend/ui-react/organisms/AdvertisingLabelWithTooltip';
import { useWebp } from '@r1-frontend/shared/hooks/useWebp';

import { useMobileHeaderContext } from '~/src/features/_layout/Header/mobile/context';

import * as ST from './styled';

interface IProps {
    item: IMenuItem,
    typeMenu?: string,
    clickHandler?: () => void,
    itemMenuType?: string,
    onClickHandlerGA: (item: string, menuType?: string) => void,
    isAvailable: boolean,
    isPromoted: boolean,
}

const Promo = ({ item, isAvailable, isPromoted, clickHandler, onClickHandlerGA, itemMenuType }: IProps): JSX.Element => {
    const { image, image_webp, title, link, add_desc, button_text, button_link, labels = [], advertising } = item;

    const [isTooltipShown, setIsTooltipShown] = useState(false);

    const clickHandlerWrapper = () => {
        if (typeof clickHandler === 'function') {
            clickHandler();
        }
        onClickHandlerGA(title || button_text || '', itemMenuType);
    };

    const src = useWebp() ? image_webp : image;

    const { isMenuScrolling } = useMobileHeaderContext();

    useEffect(() => {
        isMenuScrolling && setIsTooltipShown(false);
    }, [isMenuScrolling]);

    return (
        <ST.PromoWrapper isAvailable={isAvailable}>
            <Link
                href={link || '/'}
                prefetch={false}
                passHref
            >
                <a>
                    {advertising && (
                        <NonStaticContainer
                            $united={{
                                $bottom: 12,
                                $right: 12,
                            }}
                        >
                            <AdvertisingLabelWithTooltip
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsTooltipShown(true);
                                }}
                                companyName={advertising.companyName}
                                erid={advertising.erid}
                                tooltip={{
                                    zIndex: 999,
                                    isShown: isTooltipShown,
                                    onClose: () => setIsTooltipShown(false),
                                }}
                            />
                        </NonStaticContainer>
                    )}
                    {src &&
                        <ST.PromoImg onClick={clickHandlerWrapper}>
                            <img
                                src={src} alt={title}
                            />
                        </ST.PromoImg>
                    }
                </a>
            </Link>
            <ST.PromoTextBlock isImg={src}>
                <Link
                    href={link || '/'}
                    prefetch={false}
                    passHref
                >
                    <a>
                        {title &&
                            <ST.PromoTitle isPromoted={isPromoted} onClick={clickHandlerWrapper}>
                                <span>{title}</span>
                                {labels?.map(label =>
                                    <ST.Label
                                        key={label.id}
                                        bgColor={label.color}
                                        colorText={label.color_text}
                                        onClick={clickHandlerWrapper}
                                    >
                                        {label.title}
                                    </ST.Label>)}
                            </ST.PromoTitle>
                        }

                        {add_desc &&
                            <ST.PromoDesc onClick={clickHandlerWrapper} isImg={src}>
                                <span>{add_desc}</span>
                            </ST.PromoDesc>
                        }
                    </a>
                </Link>
                {button_text && <ST.PromoMore onClick={clickHandlerWrapper}>
                    <Link
                        href={button_link ? button_link : '/'}
                        prefetch={false}
                        passHref
                    >
                        <a><span>{button_text}</span></a>
                    </Link>
                    <img
                        src={'/static/images/icons/arrow_right_red.svg'}
                        alt={button_text}
                        height={'16px'}
                        width={'8px'}
                    />
                </ST.PromoMore>}
            </ST.PromoTextBlock>
        </ST.PromoWrapper >

    );
};

export default Promo;
